import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_RANDOM_QUESTIONS').plugin(axiosPlugin, {template: "array"});

let fetchUserRandomQuestionsAction = redux.fetchActionGet();

export const fetchUserRandomQuestions = (userId, query = {}) => fetchUserRandomQuestionsAction(`/users/${userId}/random-questions?${queryString.stringify(query)}`);
export const resetUserRandomQuestions = () => redux.actions.reset();

export const userRandomQuestions = redux.reducer();